import { enqueueSnackbar, UploadFile, DownloadFile } from 'actions';

import {
	GenerateScfRequest,
	GetSowListRequest,
	GetSowTypeRequest,
	GetSowTechsRequest,
	GetSowRmodRequest,
} from '../requests/ScfRequests.js';

export const SET_FORM_STATE = 'SET_FORM_STATE';
export const GET_SOW_LIST = 'GET_SOW_LIST';
export const GET_SOW_TYPE = 'GET_SOW_TYPE';
export const GET_SOW_TECHS = 'GET_SOW_TECHS';
export const GET_SOW_RMOD = 'GET_SOW_RMOD';

const onSetFormState = (value) => ({
	type: SET_FORM_STATE,
	formState: value
});

const onGetSowList = (value) => ({
	type: GET_SOW_LIST,
	sowList: value
});

const onGetSowType = (value) => ({
	type: GET_SOW_TYPE,
	sowType: value
});

const onGetSowTechs = (value) => ({
	type: GET_SOW_TECHS,
	sowTechs: value
});

const onGetSowRmod = (value) => ({
	type: GET_SOW_RMOD,
	sowRmod: value
});

export const SetFormState = (value) => (dispatch) => {
	dispatch(onSetFormState(value));
};

export const ProcessFileScf = (fileLocation, sowType, sowTechs, sowRmod, sran) => async (dispatch) => {
	await GenerateScfRequest(fileLocation, sowType, sowTechs, sowRmod, sran).then(response => {
		dispatch(DownloadFile(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GenerateScf = (file, sowType, sowTechs, sowRmod, sran) => async (dispatch) => {
	await UploadFile(file).then(response => {
		dispatch(ProcessFileScf(response.data, sowType, sowTechs, sowRmod, sran));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetSowList = () => async (dispatch) => {
	await GetSowListRequest().then(response => {
		dispatch(onGetSowList(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetSowType = () => async (dispatch) => {
	await GetSowTypeRequest().then(response => {
		dispatch(onGetSowType(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetSowTechs = () => async (dispatch) => {
	await GetSowTechsRequest().then(response => {
		dispatch(onGetSowTechs(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetSowRmod = () => async (dispatch) => {
	await GetSowRmodRequest().then(response => {
		dispatch(onGetSowRmod(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};
